import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import store from './store'
import VueAxios from 'vue-axios'

import * as http from './common/http'
//import * as utils from './common/utils'
//import * as common from './common/common' 

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//清除样式
import '../src/assets/css/reset.css'

Vue.config.productionTip = false

Vue.prototype.$store = store
Vue.prototype.$http = http
//Vue.prototype.$utils = utils
//Vue.prototype.$common = common
Vue.prototype.$axios = axios

Vue.use(ElementUI);

new Vue({
  router,
  store,
  axios,
  render: h => h(App)
}).$mount('#app')